
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"7","viewBox":"0 0 12 7","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.369 4.273l3.82-3.821a1.061 1.061 0 011.5 1.5L7.077 6.566a.999.999 0 01-1.414 0L1.048 1.952a1.061 1.061 0 011.5-1.5l3.82 3.82z","fill":"#535353"}})])
          )
        }
      }
    